module.exports = "/images/cooper-6.jpg";